import React from 'react';
export const SkipToContent = () => {
    return (React.createElement("a", { className: "sr-only top-0 left-0 bg-app-green-primary rounded text-white text-xl text-center z-50 focus:not-sr-only focus:m-4 focus:fixed focus:py-1 focus:px-4 block focus:outline-none ring-4", href: "#content" }, "Skip to content"));
};
